var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex w-full items-center px-2 py-1" },
    [
      _c("CircleWithInitials", {
        staticClass: "mr-2",
        attrs: { title: _vm.name, id: _vm.id },
      }),
      _c("span", { staticClass: "font-semibold text-lg" }, [
        _vm._v(_vm._s(_vm.name)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }